export const getAvatarFlexStyles = (theme, isIntroState, avatarFlexHeight) => {
    const marginBottom = theme.spacing[400];
    if (!avatarFlexHeight) {
        return {
            marginBottom,
        };
    }
    const duration = theme.motionDuration.slower;
    const easing = theme.motionEasing.easeInOut;
    return {
        overflow: 'hidden',
        transition: [
            `transform ${duration} ${easing}`,
            `max-height ${duration} ${easing}`,
            `margin-bottom ${duration} ${easing}`,
        ].join(', '),
        transform: `translateY(0)`,
        maxHeight: `${avatarFlexHeight}px`,
        marginBottom,
        ...(!isIntroState && {
            // -10px because this element is bigger than the disclaimer
            // and it peeks above it slightly before disappearing
            transform: `translateY(-${avatarFlexHeight - 10}px)`,
            maxHeight: 0,
            marginBottom: 0,
        }),
    };
};
//# sourceMappingURL=AdviceAgentChatbotUi.styles.js.map